import { Reducer } from 'redux';
import ActionTypes, { TChat, TMessage, TRoom, TSocketState } from './types';

const updateChat = (prevChat: TSocketState['chat'], chat: TSocketState['chat']): TSocketState['chat'] => {
  if (!prevChat && !chat) return null;
  if (!prevChat) return chat;
  if (!chat) return null;

  const message = chat.messages[0];
  if (!message) return null;

  const newMessages: TMessage[] = [];

  const prevMessages = prevChat.messages
    .filter((item) => item.roomId === message.roomId)
    .reduce((acum, item) => {
      acum[item.absnum] = item;
      return acum;
    }, {} as Record<string, TMessage>);

  chat.messages.forEach((item) => {
    if (prevMessages[item.absnum]) {
      prevMessages[item.absnum] = item;
    } else {
      newMessages.push(item);
    }
  });

  const messages = [...newMessages, ...Object.values(prevMessages)].sort((a, b) => (a.absnum > b.absnum ? 1 : -1));

  return { ...chat, messages, page: prevChat.page };
};

export const initialState: TSocketState = {
  data: null,
  chat: null,
  likedMessage: null,
  currentMessage: null,
  loading: false,
  errors: undefined,
  room: null,
  event: null,
};

const reducer: Reducer<TSocketState> = (state = initialState, action): TSocketState => {
  switch (action.type) {
    case ActionTypes.SET_CALL_ACTION_ID_ROOM:
      return { ...state, room: state.room ? { ...state.room, callActionId: action.payload } : null };
    case ActionTypes.SET_ROOM: {
      const room = action.payload as TRoom;
      return {
        ...state,
        room,
        currentMessage: room.questions?.find((item) => item.iscurrent === 1 && item.isresponse !== 1 && item.ispublish !== 1),
      };
    }
    case ActionTypes.SET_NEW_MESSAGE:
      return {
        ...state,
        chat: state.chat ? { ...state.chat, messages: [...state.chat.messages, action.payload] } : { messages: [action.payload], page: 1, pages: 1 },
      };
    case ActionTypes.SET_UPDATE_MESSAGE: {
      const message = action.payload as TMessage;
      return {
        ...state,
        chat: state.chat
          ? {
              ...state.chat,
              messages: state.chat.messages.map((item) => {
                if (item.absnum === message.absnum) {
                  return message;
                }
                return item;
              }),
            }
          : null,
      };
    }
    case ActionTypes.SET_DELETE_MESSAGE: {
      const message = action.payload as TMessage;
      return {
        ...state,
        chat: state.chat ? { ...state.chat, messages: state.chat.messages.filter((item) => item.absnum !== message.absnum) } : null,
        room: state.room ? { ...state.room, pinMessage: state.room.pinMessage?.absnum === message.absnum ? null : state.room.pinMessage } : null,
        currentMessage: state.currentMessage && state.currentMessage.absnum === message.absnum ? null : state.currentMessage,
      };
    }
    case ActionTypes.SET_CHAT: {
      const chat = action.payload as TChat;
      return {
        ...state,
        chat: updateChat(state.chat, chat),
      };
    }
    case ActionTypes.GET_MESSAGES_S: {
      const chat = action.payload as TChat;
      return {
        ...state,
        chat: state.chat ? { ...chat, messages: [...chat.messages, ...state.chat.messages] } : null,
      };
    }
    case ActionTypes.SHOW_EVENT_R:
      return { ...state, loading: true, errors: '' };
    case ActionTypes.SHOW_EVENT_S:
      return { ...state, event: action.payload, loading: false, errors: '' };
    case ActionTypes.SHOW_EVENT_E:
      return { ...state, errors: action.payload, loading: false };
    default:
      return state;
  }
};

export { reducer as SocketsReducer };
